import { Grid, Tooltip, Typography } from '@mui/material';
import { CopyButton } from '@tassat/button';
import { ButtonType } from '@tassat/button/src/CopyButton';
import { Hide as HideIcon, Show as ShowIcon } from '@tassat/icon';
import * as React from 'react';

import { SecretInputProps, SecretsModalProps } from './types';

const SecretInput = (props: SecretInputProps) => {
    const {
        label,
        name,
        id,
        value,
        classes,
        disabled,
        formattedValue,
        showUserKey = true
    } = props;
    const [ inputType, setInputType ] = React.useState<'password' | 'text'>(showUserKey ? 'text' : 'password');

    const setInputTypeValue = () => {
        let typeValue;

        if (inputType === 'text') {
            typeValue = 'password';
        } else {
            typeValue = 'text';
        }
        setInputType(typeValue);
    };

    return (
        <Grid
            container
            direction='row'
            xl={12}
        >
            <Grid
                item
                xl={12}
            >
                <label
                    className={classes.inputLabel}
                    htmlFor={name}
                >
                    {label}
                </label>
            </Grid>
            <Grid
                alignItems='center'
                container
                item
                xl={12}
                xs={12}
            >
                <Grid
                    className={classes.field}
                    item
                    xl={10}
                    xs={10}
                >
                    <div className={classes.inputContainer}>
                        <input
                            className={classes.textInput}
                            disabled={disabled}
                            id={id}
                            name={name}
                            type={inputType}
                            value={value}
                        />
                    </div>
                </Grid>
                <Grid
                    container
                    item
                    justifyContent={!showUserKey ? 'space-evenly' : 'flex-start'}
                    xl={2}
                    xs={2}
                >
                    {!showUserKey ?
                        <Tooltip
                            disableInteractive
                            title={inputType === 'text' ? 'Hide Secret' : 'Show Secret'}
                        >
                            <Grid>
                                {inputType === 'text' ?
                                    <HideIcon
                                        className={classes.hideSecretsIcon}
                                        iconColor='#000'
                                        onClick={setInputTypeValue}
                                    />
                                    : (
                                        <ShowIcon
                                            className={classes.showSecretsIcon}
                                            onClick={setInputTypeValue}
                                        />)}
                            </Grid>
                        </Tooltip>
                        : null}
                    <CopyButton
                        buttonType={ButtonType.SMALL}
                        textToCopy={formattedValue ?? value}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};

const SecretsModal = (props: SecretsModalProps) => {
    const { userCredentials: { apiPairKeys, userApiKey }, classes } = props;

    return (
        <Grid
            alignItems='center'
            container
            direction='column'
            xs={12}
        >
            <Grid
                className={classes.secretsContainer}
                item
                xs={12}
            >
                <SecretInput
                    classes={classes}
                    disabled
                    id='apy_key'
                    label='API Key'
                    name='API Key'
                    value={userApiKey}
                />
                <SecretInput
                    classes={classes}
                    disabled
                    formattedValue={`-----BEGIN PRIVATE KEY-----\n${apiPairKeys.privateKey}\n-----END PRIVATE KEY-----`}
                    id='secret_key'
                    label='Secret'
                    name='Secret'
                    showUserKey={false}
                    value={apiPairKeys.privateKey}
                />
            </Grid>
            <Grid
                className={classes.textContainer}
                item
                xs={12}
            >
                <Typography>
                    {`Copy your Key and Secret and keep them safe.
                    You will only be able to view the secret once, if this window is closed the secret can't be retrieved.`}
                </Typography>
            </Grid>
        </Grid>
    );
};

export default SecretsModal;